import React from "react";

const Hero = ({ openPreOrder }) => (
  <section
    id="home"
    className="flex flex-col items-center justify-center text-center p-8 md:p-16 text-white min-h-screen"
    style={{ backgroundColor: "#1546ea" }}
  >
    <h1 className="text-4xl md:text-6xl font-extrabold mb-4">
      Hotel-Hub: Your Partner for Hospitality Solutions
    </h1>
    <p className="italic text-xl md:text-2xl mb-4">"Go Offline To Online"</p>
    <p className="text-lg md:text-xl opacity-90 max-w-2xl mb-6">
      We provide cutting-edge software solutions to streamline operations, enhance guest experience, and boost revenue for hotels and resorts.
    </p>
    <div className="flex flex-col sm:flex-row gap-4">
      <a
        href="https://demo.hotel-hub.com/"  // replace with your demo URL
        target="_blank"
        rel="noopener noreferrer"
        className="bg-white text-blue-600 font-bold py-3 px-8 rounded-full hover:bg-gray-100 transition transform hover:scale-105"
      >
        View Demo
      </a>
      <button
        onClick={openPreOrder}
        className="bg-blue-600 text-white font-bold py-3 px-8 rounded-full hover:bg-blue-700 transition transform hover:scale-105"
      >
        Pre-Order
      </button>
    </div>
  </section>
);

export default Hero;
